// extracted by mini-css-extract-plugin
export default {"heading":"Rj-z","list":"Sj-z"};